module.exports = __webpack_public_path__ + "img/Cheia.507bb084.svg";